import Vue from "vue";
import Router from "vue-router";
// 前台门户
import portalSite from "./portalSite";
// 前台门户
import studentSide from "./studentSide";
import xcSite from "./xcSite";
import aiTraining from "./aiTraining";

Vue.use(Router);

import { Message } from "element-ui";
import { getToken, removeToken } from "@/utils/auth";
import store from "../store";

const hasToken = getToken();
const createRouter = new Router({
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [...portalSite, ...studentSide, ...xcSite, ...aiTraining]
});
export default createRouter;



// WEBPACK FOOTER //
// ./src/router/index.js